import React from 'react'

export function Show({ condition = false, children }) {
  return condition ? children : <></>
}

export function Hide({ condition = false, children }) {
  return !condition ? children : <></>
}
